module.exports = window.wp?.hooks;